import React from 'react';
import {BookedSpaceCalendarView} from "../../../types/model/orm/BookedSpaceCalendarView";
import {AdminSpaceUsageCardListItem} from "./AdminSpaceUsageCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type AdminSpaceUsageCardListProps = {
  items?: BookedSpaceCalendarView[];
}

const AdminSpaceUsageCardList = ({
  items,
}: AdminSpaceUsageCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item) =>
        <AdminSpaceUsageCardListItem
          key={item.id}
          item={item}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const AdminSpaceUsageCardListWithLoader = withLoader(AdminSpaceUsageCardList, skeletonLoader);

export {
  AdminSpaceUsageCardList,
  AdminSpaceUsageCardListWithLoader
};
